
import { Button } from '@/shared/components/ui/button';
import { Building2 } from 'lucide-react';
import type { AuthRole } from '@/modules/auth/types/auth';

interface CareerNavbarProps {
  onHRPortal: () => void;
  onAdminLogin: () => void;
  isAuthenticated: boolean;
  role?: AuthRole;
}

export default function CareerNavbar({
  onHRPortal,
  onAdminLogin,
  isAuthenticated,
  role,
}: CareerNavbarProps) {

  const hrTeamRoles: AuthRole[] = [
    'hr',
    'recruiter',
    'operations',
    'manager',
  ];

  const portalLabel = isAuthenticated
    ? role === 'admin'
      ? 'Admin Portal'
      : role && hrTeamRoles.includes(role)
        ? 'HR Portal'
        : 'Candidate Portal'
    : 'Login';


  return (
    <nav className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/90 backdrop-blur-lg">
      <div className="mx-auto w-full max-w-7xl px-2.5 min-[390px]:px-3 sm:px-5 md:px-6 lg:px-8">
        <div className="flex min-h-14 w-full items-center justify-between gap-1.5 py-2 sm:min-h-16 sm:gap-4">
          {/* Logo and Company Name */}
          <div className="flex min-w-0 flex-1 items-center gap-1.5 sm:gap-3">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gradient-to-br from-blue-600 to-indigo-600 sm:h-9 sm:w-9">
              <Building2 className="h-4 w-4 text-white sm:h-5 sm:w-5" />
            </div>

            <span className="whitespace-nowrap text-[10px] font-bold leading-tight tracking-tight text-gray-900 min-[375px]:text-[11px] min-[400px]:text-xs sm:text-base md:text-lg lg:text-xl">
              Dharohar Land Corp
            </span>
          </div>

          {/* Navigation Actions */}
          <div className="flex shrink-0 items-center gap-1 min-[390px]:gap-1.5 sm:gap-3 md:gap-4">
            <button
              type="button"
              onClick={() => {
                document.getElementById('open-positions')?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start',
                });
              }}
              className="whitespace-nowrap rounded-md px-1 py-2 text-[10px] font-medium text-blue-600 transition-colors hover:text-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 min-[390px]:text-xs sm:px-2 sm:text-sm"
            >
              Careers
            </button>

            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={onAdminLogin}
              className="h-8 whitespace-nowrap px-1.5 text-[10px] sm:h-9 sm:px-4 sm:text-sm"
            >
              {portalLabel}
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
}
